import { Box, Divider, Collapse as MuiCollapse, Typography, CardActionArea } from '@mui/material';
import { FC, ReactNode, useEffect, useState } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Icon } from 'shared/ui/Icon';
import { Paper } from 'shared/ui/Paper';

type CollapseProps = {
	label: ReactNode;
	children: ReactNode;
	defaultOpen?: boolean;
	headerExtra?: ReactNode;
	expandSignal?: unknown;
};

const Collapse: FC<CollapseProps> = ({ label, children, defaultOpen = true, headerExtra, expandSignal }) => {
	const [isOpen, setIsOpen] = useState(defaultOpen);

	useEffect(() => {
		if (expandSignal !== undefined) setIsOpen(true);
	}, [expandSignal]);

	return (
		<Paper sx={{ display: 'flex', flexDirection: 'column', padding: 0, width: '100%' }}>
			<Box sx={{ display: 'flex', alignItems: 'center', borderRadius: 5 }}>
				<CardActionArea
					onClick={() => setIsOpen((prev) => !prev)}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						padding: 2,
						flex: 1,
						minWidth: 0,
					}}
				>
					<Typography variant={'h6'} color={ColorPalette.astronaut} sx={{ minWidth: 0, flex: 1 }}>
						{label}
					</Typography>
					<Icon
						id={'custom_arrow_down'}
						style={{
							width: '14px',
							height: '7px',
							color: ColorPalette.astronaut,
							transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
							transition: 'transform .3s',
							flexShrink: 0,
							marginLeft: '12px',
						}}
					/>
				</CardActionArea>
				{headerExtra && <Box sx={{ flexShrink: 0, paddingRight: 2 }}>{headerExtra}</Box>}
			</Box>
			<MuiCollapse in={isOpen}>
				<Divider sx={{ mt: 1 }} />

				{children}
			</MuiCollapse>
		</Paper>
	);
};

export default Collapse;
